import { Component,Input, OnInit, ViewChild} from '@angular/core';
import { GlobalService } from '../global-service.service';
import { MatExpansionPanel} from '@angular/material/expansion';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
    selector: 'app-kontakte',
    templateUrl: './kontakte.component.html',
    styleUrls: ['../css/pasura.css'],
    host: { '(document:keyup)': 'onKeyUp($event)' },
    standalone: false
})
export class KontakteComponent implements OnInit {

	@ViewChild('panSearch',   		 {static: false}) private panSearch: MatExpansionPanel;
	@ViewChild('tabGroupKontakt',  {static: false}) private tabGroupKontakt;
	
  	SuchText="";
  	kontakte:any;
  	orgKontakt:any;
  	displayedColumns =['ID','Name'];
  	
  	
  	
	constructor(private toastr: ToastrService, public globserv: GlobalService, private router: Router) 
  	{
 	}	

  	ngOnInit(): void 
  	{
  		this.globserv.getPasuraAction().subscribe((pasuraAction) => {
	      console.log("pasuraAction= " +pasuraAction)
	      if (typeof pasuraAction === 'string')
	      {
		      if (pasuraAction=="contactNew")
		      {
		      	this.newContact();
		      	
		      }else if(pasuraAction=="panSearchClose")  
		      {
		      	this.panSearch.close();
		      
		      }else if (pasuraAction.startsWith('contactDelete'))
		      {
		        
		      	this.showDeleteToaster();
		      	
		      }else if (pasuraAction.startsWith('LogOut'))	
		      {
		      	console.log("do Logout");
		      	this.kontakte=undefined;
		      	this.globserv.kontakt=undefined
		      	this.orgKontakt=undefined;		      	
		      	
		      	this.globserv.policen= undefined;
	       		this.globserv.setPasuraAction("resetPolOrg");
		      
		      }else if (pasuraAction.startsWith('loadPolice'))
		      {
		      	var actionArray = pasuraAction.split(';');
		      	this.loadContactPolNr(actionArray[1]);	
		      	
		      }else if (pasuraAction.startsWith('loadContact'))
		      {
		      	var actionArray = pasuraAction.split(';');
		      	
					console.log("ArraySize=" + actionArray.length + ' / ' + pasuraAction );
					if (actionArray.length>2)
					{
						if (actionArray[2]=='reload')
						{
							this.loadContact(actionArray[1], 1);	
	
						}else{
						
							this.loadContact(actionArray[1], 0);
						}
						
					}else{
						this.loadContact(actionArray[1], 0);	
						this.globserv.setPasuraAction('setTabGroupKontakte');
					}   
		      }
		   }
    	}); 	 
  	}
  
 
  
  showDeleteToaster()
  {
  
    this.toastr.success("",'Kontakt wirklich löschen?',
    {
        closeButton: false,
        enableHtml:false,
        progressBar:true,
        timeOut:6000,
        extendedTimeOut:6000,
        
        
    }).onTap.pipe(take(1)).subscribe(() => this.deletContact());
 
  }
  
  deletContact() 
  {
  		var data={};
		
		var myresult;
		this.globserv.getBackendData("/v1/deleteContact/?nr="+this.globserv.kontakt.Bexio.nr,data).subscribe(
	 
				result => 
  					myresult = result,
  					
  					err => {
  									this.globserv.setPasuraAction({"msg":{"title":"Fehlmeldung","txt":"Fehler beim löschen des Kontaktes " +this.globserv.kontakt.Bexio.nr,data}});	 
  					 				console.log("Error");
  					 				console.log(err);
  					 		  },
    			
    			() => {  
    						console.log("myresult getContact " + JSON.stringify(myresult));
    						
    						if (myresult.Status=="OK")  
    						{
    							this.globserv.kontakt=undefined;
    							this.kontakte=undefined;

    						}else{
    						
								this.globserv.setPasuraAction({"msg":{"title":"Fehlmeldung","txt":"Fehler beim löschen des Kontaktes " +this.globserv.kontakt.Bexio.nr,data}});	       						
    						}
    					}
		);
  }
  
  onKeyUp(ev:KeyboardEvent) 
  {
    if(ev.keyCode==13 )
    {
    	if (this.panSearch.expanded)
    	{
    		if(this.SuchText.length>2)
    		{
    			this.doSearch();
    		}	
   	}
    }
  }

  	getContact(persNr, persArt, idx)
  	{
		  		
  		var data={};
		
		var myresult;
		this.globserv.setPasuraAction("resetSchadenfall");
		
		this.globserv.getBackendData("/v1/getContact/?nr="+persNr,data).subscribe(
	 
				result => 
  					myresult = result,
  					
  					err => {
  								  	this.globserv.setPasuraAction({"msg":{"title":"Fehler beim laden des Kontaktes " + persNr}});	 
  					 				console.log("Error");
  					 				console.log(err);
  					 		  },
    			
    			() => {  
    						
    						//console.log("myresult getContact " + JSON.stringify(myresult));
    						if (myresult.Bexio!=undefined )  
    						{
    							if (persArt=="VN")
    							{   		
    								this.globserv.policen[idx].VN= Object.assign({},myresult); 
    							
    							}else if( persArt=="PZ")
    							{
    								this.globserv.policen[idx].PZ= Object.assign({},myresult);
    							}
    						}
    						//console.log("myresult " +JSON.stringify(this.globserv.policen));
    					}
		);

  	}
		
	newContact()
  	{
  		var data={};
		
		var myresult;
		this.globserv.getBackendData("/v1/newContakt",data).subscribe(
	 
				result => 
  					myresult = result,
  					
  					err => {
  									this.globserv.setPasuraAction({"msg":{"title":"Fehler beim erstellen eines neuen Kontaktes"}});
  					 				console.log("Error");
  					 				console.log(err);
  					 		  },
    			
    			() => {  
    						//console.log("myresult newContact " + JSON.stringify(myresult));
    						if(myresult.Status=="OK")  
    						{
    							this. loadContact(myresult.Nr,0);
    						}else{
    						
    							this.globserv.setPasuraAction({"msg":{"title":"Fehler beim erstellen eines neuen Kontaktes"}});
    						}
    					}
		);
  	}
  	
	doSearch()
  	{	
  		var myresult;
  		
  		this.kontakte=undefined;
  		this.globserv.kontakt=undefined;
  		this.globserv.setPasuraAction('findPolicen');
  		 
		
		var data={"Volltext":{"Suche":""},"TimeStamp" :  new Date().getTime()};
		data.Volltext.Suche=this.SuchText;
		
		
				
		this.globserv.getBackendData("/v1/search",data).subscribe(
	 
				result => 
  					myresult = result,
  					
  					err => {
  								this.globserv.setPasuraAction({"msg":{"title":"Fehler beim suchen von Kontakten"}});
  					 			console.log("Error");
  					 			console.log(err);
  					 		},
    			
    			() => {       		
    						this.kontakte= myresult.Kontakte;
    					}
		);
  	}
  	
  	selectContact(row)  
  	{
		console.log("selectContact " + row.ID);  
		this.loadContact(row.ID,0);
		this.panSearch.close();
		
  	}
  	
  	 
  loadContact(nr, reload)
  {
  		var myresult;
  		var data={};
  		this.globserv.setPasuraAction("resetSchadenfall");
  		
  		if (reload==0) 
  		{
	  		this.globserv.policen=[{}];
  			this.globserv.kontakt=undefined;
  		}
  		
  		console.log("loadContact " +nr);
  		 
  		var resultData;
  		this.globserv.getBackendData("/v1/getContactPolicen/?nr="+nr +"&TimeStamp=" +new Date().getTime(),data).subscribe(
			result => resultData=result, 
		 	
  					 err => {
  					 				this.globserv.setPasuraAction({"msg":{"title":"Fehlmeldung","txt":"Kontakt (" + nr + ") konnte nicht geladen werden!"}});	  					 				
  					 		  },
		       () => {
		       
		        	console.log(JSON.stringify(resultData));
	       		this.orgKontakt= Object.assign({},resultData.Contact);
	       		this.globserv.kontakt= JSON.parse(JSON.stringify(this.orgKontakt));
	       		
	       		console.log("Policen: "+  JSON.stringify( resultData.Policen));
	       		
	       		if (resultData.Policen!=undefined && resultData.Policen.length>0)
	       		{
	       			this.globserv.policen= resultData.Policen;
	       			this.globserv.setPasuraAction("resetPolOrg"); 	
	       			this.globserv.setPasuraAction("loadSchadenfaellePolice;"+ this.globserv.policen[0].PolicenNr )	
	       			console.log("Reload -> " + JSON.stringify(this.globserv.policen));	
	       									
	       		}else{
										       		
						this.globserv.policen= [{}];
	       			this.globserv.setPasuraAction("resetPolOrg");
	       		}
	       		
	       		if (reload>0) 
  					{
  						this.globserv.setPasuraAction("reload");
					}
		       }
		); 
  }
  
  loadContactPolNr(nr)
  {
  		var myresult;
  		var data={};
  		
  		this.globserv.policen=[{}];
  		this.globserv.kontakt=undefined;
  		this.globserv.setPasuraAction("resetSchadenfall");
  		  		
  		console.log("loadContact " +nr);
  		 
  		var resultData;
  		this.globserv.getBackendData("/v1/getContactPolNr/?nr="+nr +"&TimeStamp=" +new Date().getTime(),data).subscribe(
			result => resultData=result, 
		 	
  					 err => {
  					 				this.globserv.setPasuraAction({"msg":{"title":"Fehlmeldung","txt":"Police (" + nr + ") konnte nicht geladen werden!"}});	  					 				
  					 		  },
		       () => {
		       
		        	console.log("result ->" + JSON.stringify(resultData));
	       		this.orgKontakt= Object.assign({},resultData.Contact);
	       		this.globserv.kontakt= JSON.parse(JSON.stringify(this.orgKontakt));
	       		
	       		console.log("Policen: "+ (resultData.Policen!=undefined)) ;
	       		
	       		if (resultData.Policen!=undefined)
	       		{
	       			this.globserv.policen= resultData.Policen;
	       			this.globserv.setPasuraAction("resetPolOrg"); 									
	       		}else{
										       		
						this.globserv.policen= [{}];
	       			this.globserv.setPasuraAction("resetPolOrg");
	       		}
		       }
		); 
  }    
  
  
  
  kontaktChanged()
  {
  		if (this.globserv.kontakt==undefined)
  		{
			return false;  		
  		}
  		return JSON.stringify(this.orgKontakt)==JSON.stringify(this.globserv.kontakt);
  }
  
  resetKontakte()
  {
  		this.globserv.kontakt= JSON.parse(JSON.stringify(this.orgKontakt));
  }
  
  saveKontakte()
  {
  		
		var data= Object.assign({},this.globserv.kontakt);
			 
  		var resultData;
  		this.globserv.getBackendData("/v1/saveContact",data).subscribe(
		result => resultData=result, 
		 	
  					 err => {
  					 	this.globserv.setPasuraAction({"msg":{"title":"Fehlmeldung","txt":"Fehler beim speichern von Kontakt!"}});	
  					 	this.globserv.setPasuraAction("findPolicen");  	
  					 	console.log("Error");
			  			console.log(err);				 				
  					 		  },
		       () => {
		       
		       		//console.log("resultData " +JSON.stringify(resultData));
		       		if (resultData.Status=='OK')
		       		{
		       			this.orgKontakt= JSON.parse(JSON.stringify(this.globserv.kontakt));
		       			this.globserv.doChangeKontakt();
		       			
		       		}else{
		       			this.globserv.setPasuraAction({"msg":{"title":"Fehlmeldung","txt":"Fehler beim speichern von Kontakt!"}});	
		       		}
			}    
		); 
  }
}
